// extracted by mini-css-extract-plugin
export default {"buttonGroup":"payment_buttonGroup__S0zTJ","buttonGroup_2":"payment_buttonGroup_2__PsW-p"};